import { render, staticRenderFns } from "./SeatsExceededBanner.vue?vue&type=template&id=b1e000d8&scoped=true&"
import script from "./SeatsExceededBanner.vue?vue&type=script&lang=js&"
export * from "./SeatsExceededBanner.vue?vue&type=script&lang=js&"
import style0 from "./SeatsExceededBanner.vue?vue&type=style&index=0&id=b1e000d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e000d8",
  null
  
)

export default component.exports